<template>
  <div class="container-fluid">
    <signature-form
      :loading="loading"
      :signatureData="signature"
      :formErrors="formErrors"
      @signatureSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSignature from "../defaultSignature";
import SignatureForm from "../partials/SignatureForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    SignatureForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      signature: cloneDeep(defaultSignature),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(signature) {
      this.loading = true;

      const signatureData = cloneDeep(signature);
      delete signatureData.id;

      try {
        await this.$store.dispatch("signatures/add", signatureData);
        this.$notify({
          type: "success",
          message: this.$t("SIGNATURES.SIGNATURE_ADDED"),
        });
        const signature = await this.$store.getters[
          "signatures/signature"
        ];
        this.$emit("onViewSignature", signature, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
